import consoleLogger from '../../logger/consoleLogger';
import { CurrentPage } from '../../pages/currentPage';

const DEATH_TIMER_DELAY = 1000 * 60;
const logger = consoleLogger.getPrefixedCopy('DEATH TIMER');

export class DeathTimer {
    private static timer: Timer;

    public static init() {
        $(document).on('visibilitychange', ()=>{
            if (document.hidden === true) {
                logger.warning('tab inactive, stop timer');
                this.stopTimer();
            } else {
                logger.warning('tab active again, start timer');
                this.restartTimer();
            }
        });

        $(window).on('blur', () => {
            logger.warning('tab inactive, stop timer');
            this.stopTimer();
        });
        $(window).on('focus', () => {
            logger.warning('tab active again, start timer');
            this.restartTimer();
        });
        this.restartTimer();
    }

    public static stopTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    public static restartTimer() {
        logger.warning('Restarting death timer');

        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.timer = window.setTimeout(() => {
            CurrentPage.reload();
        }, DEATH_TIMER_DELAY);
    }
}
